import { render, staticRenderFns } from "./banner_mob.vue?vue&type=template&id=e5ada174&scoped=true"
import script from "./banner_mob.vue?vue&type=script&lang=js"
export * from "./banner_mob.vue?vue&type=script&lang=js"
import style0 from "./banner_mob.vue?vue&type=style&index=0&id=e5ada174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ada174",
  null
  
)

export default component.exports